import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Button, Col, DatePicker, Modal, Row } from 'antd';
import { isMobile } from 'react-device-detect';
import BaseSelect from './Elements/BaseSelect';
import { assignTelesaleFollowUp } from '@/redux/actions/telesaleFollowUpActions';

class TelesaleFollowUpAssignForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false
        };
    }

    async handleSubmit(e) {
        e.preventDefault();
        this.props.form.validateFields(['staff_ids', 'deadline'], async (err, values) => {
            if (!err) {
                this.setState({ isLoading: true })
                try {
                    values.customer_ids = this.props.customerIds;
                    values.deadline = values.deadline ? values.deadline.format("YYYY-MM-DD HH:mm") : null;
                    console.log(values);
                    await this.props.assignTelesaleFollowUp(values).then(res => {
                        this.onCancel()
                    }).catch(err => {
                        this.setState({ isLoading: false });
                    });
                } catch (error) {
                    this.setState({ isLoading: false });
                }
                console.log(values)
            }
        });
    }

    onCancel() {
        this.props.form.resetFields();
        this.setState({ isLoading: false })
        this.props.onCancel();
    }

    render() {
        const { isLoading } = this.state;
        const { visible, sales } = this.props;
        const { getFieldDecorator } = this.props.form;

        return (
            <>
                <Modal
                    title="Giao cho nhân viên telesale"
                    visible={visible}
                    header={false}
                    onOk={(e) => this.handleSubmit(e)}
                    width={isMobile ? '100%' : '40%'}
                    onCancel={() => this.onCancel()}
                    maskClosable={false}
                    footer={[
                        <Button key="back" onClick={() => this.onCancel()}>
                            Cancel
                        </Button>,
                        <Button
                            loading={isLoading}
                            key="submit"
                            type="primary"
                            onClick={(e) => this.handleSubmit(e)}
                        >
                            OK
                        </Button>,
                    ]}
                >
                    <Form layout='vertical'>
                        <Row gutter={16}>
                            <Col xs={24} md={24}>
                                <Form.Item label="Nhân viên telesale">
                                    {getFieldDecorator("staff_ids", {
                                        rules: [
                                            {
                                                required: true,
                                                message: "Vui lòng chọn!",
                                            },
                                        ],
                                        initialValue: []
                                    })(
                                        <BaseSelect
                                            options={sales ?? []}
                                            optionValue="user_id"
                                            optionLabel="display_name"
                                            placeholder="Chọn 1 hoặc nhiều nhân viên telesale"
                                            defaultText="Chọn nhân viên telesale"
                                            showSearch={true}
                                            mode="multiple"
                                            style={{ width: '100%' }}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={24}>
                                <Form.Item label="Deadline">
                                    {getFieldDecorator("deadline", {
                                        rules: [
                                            {
                                                required: true,
                                                message: "Vui lòng chọn!",
                                            },
                                        ],
                                        initialValue: null
                                    })(
                                        <DatePicker
                                            style={{ width: '100%' }}
                                            showTime={{ format: 'HH:mm' }}
                                            format="DD/MM/YYYY HH:mm"
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Modal>
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        sales: state.config.sales,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        assignTelesaleFollowUp: (data) => dispatch(assignTelesaleFollowUp(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'TelesaleFollowUpAssignForm' })(TelesaleFollowUpAssignForm));
